import { useTranslation } from 'react-i18next';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { InvoiceDiscrepancy } from 'services/invoiceDiscrepancies/types';
import { Alert } from 'components/Display/Alert';
import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { Button } from 'components/Form/Button/Button';

export const DiscrepanciesBanner = () => {
  const { t } = useTranslation();
  const { service } = useNavigationContext<InvoiceDiscrepancy>();
  const numberOfErrors = service.useNumberOfActiveItems();
  const focusOnCurrentItem = service.focusOnCurrentItem;

  if (numberOfErrors === 0) {
    return null;
  }

  return (
    <Alert withoutIcon severity="error" fullWidth>
      <div className="flex w-full items-center justify-between">
        <div>
          <p>{t('invoiceVerification:detailsPage.discrepanciesBanner.title')}</p>
        </div>
        <div className="flex gap-1">
          <Badge type="indicator" color={BadgeColor.red}>
            {t('invoiceVerification:detailsPage.discrepanciesBanner.badge', { count: numberOfErrors })}
          </Badge>
          {numberOfErrors > 1 ? (
            <>
              <Button
                variant="secondary-danger"
                size="extra-small"
                onClick={service.moveToPreviousItem}
                iconOnly
                LeftIcon={ChevronUpIcon}
                analyticsId="invoiceVerification:previous_error"
              />
              <Button
                variant="secondary-danger"
                size="extra-small"
                onClick={service.moveToNextItem}
                iconOnly
                LeftIcon={ChevronDownIcon}
                analyticsId="invoiceVerification:next_error"
              />
            </>
          ) : (
            <>
              <Button
                variant="secondary-danger"
                size="extra-small"
                onClick={focusOnCurrentItem}
                analyticsId="invoiceVerification:errors_focus_first"
              >
                {t('invoiceVerification:detailsPage.discrepanciesBanner.focusOnError')}
              </Button>
            </>
          )}
        </div>
      </div>
    </Alert>
  );
};
